import { call, put, takeLatest } from 'redux-saga/effects'
import { CodeConductActionTypes, CodeConductActionCreators } from '../reducers/CodeConductRedux'
import CodeConductAPI from '../services/api/entities/codeConductContract'

function* checkConsentType() {
  try {
    // Call the API to check consent type for code_conduct permission
    const result = yield call(CodeConductAPI.checkConsentType)

    if (result.response && result.response.data && result.response.data.consentType) {
      const consentType = result.response.data.consentType;

      let documentUrl = null

      if (consentType === 'ACCEPTANCE') {
        // Get document URL for CODE_CONDUCT using the correct endpoint
        try {
          const pdfResult = yield call(CodeConductAPI.getDocumentUrl, 'code-conduct')
          documentUrl = pdfResult && pdfResult.response && pdfResult.response.data.url
        } catch (docError) {
          console.warn('Could not fetch document URL:', docError)
          // Continue with consent type check even if document URL fails
        }
      }

      yield put(CodeConductActionCreators.checkConsentTypeSuccess({
        consentType,
        documentUrl,
      }))
    } else {
      yield put(CodeConductActionCreators.checkConsentTypeFailure({
        message: 'Invalid response from consent type API'
      }))
    }
  } catch (error) {
    console.error('Error checking consent type:', error)
    yield put(CodeConductActionCreators.checkConsentTypeFailure({
      message: error.message || 'Error al verificar el tipo de consentimiento',
      error: error
    }))
  }
}

function* acceptCodeConductContract() {
  try {
    const response = yield call(CodeConductAPI.acceptCodeConductContract, 'code-conduct')
    yield put(CodeConductActionCreators.acceptCodeConductContractSuccess(response.response.data))
  } catch (error) {
    console.error('Error accepting code conduct contract:', error)
    yield put(CodeConductActionCreators.acceptCodeConductContractFailure({
      message: error.message || 'Error al aceptar el contrato de código de conducta',
      error
    }))
  }
}

// Check if user has code_conduct permission (following NetworkContractSagas pattern)
function* checkCodeConductPermission() {
  try {
    const response = yield call(CodeConductAPI.checkCodeConductPermissions)
    
    if (response.status === 200) {
      // User has permission, hide modal
      yield put(CodeConductActionCreators.setShowCodeConductModal(false))
    } else {
      // User lacks permission, should show modal and check consent type
      yield put(CodeConductActionCreators.setShowCodeConductModal(true))
      // Now check consent type since user needs to see the modal
      yield call(checkConsentType)
    }
  } catch (error) {
    console.error('Error checking user permissions:', error)
    // On error, assume user needs to see the modal (lacks permission)
    yield put(CodeConductActionCreators.setShowCodeConductModal(true))
    // Also check consent type in case of error
    yield call(checkConsentType)
  }
}

// Export individual saga functions for use in main sagas index
export { checkConsentType, acceptCodeConductContract, checkCodeConductPermission }

export default function* codeConductSaga() {
  yield takeLatest(CodeConductActionTypes.CHECK_CONSENT_TYPE, checkConsentType)
  yield takeLatest(CodeConductActionTypes.ACCEPT_CODE_CONDUCT_CONTRACT, acceptCodeConductContract)
  yield takeLatest(CodeConductActionTypes.CHECK_CODE_CONDUCT_PERMISSION, checkCodeConductPermission)
}
